// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__UJvSm","footer":"ModalFilter_footer__gmEEH"};